import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, Route, useHistory } from 'react-router-dom'; // @ts-expect-error Could not find a declaration file for module

import { getLesson } from '../../../selectors/lessonSelectors';
import { useAcademyLanguage } from '../../http';

const useWatchAcademyLanguage = props => {
  const {
    setLanguages,
    resetLanguages
  } = useAcademyLanguage();
  const history = useHistory();
  const match = matchPath(history.location.pathname, props);
  let lessonId;
  let paramLanguage;

  if (match && match.params) {
    lessonId = match.params.lessonId;
    paramLanguage = match.params.language;
  }

  const lesson = useSelector(state => getLesson(state, {
    lessonId
  }));
  const lessonLanguage = lesson ? lesson.toJS().language : null;
  useEffect(() => {
    setLanguages({
      lessonLanguage,
      paramLanguage: paramLanguage || null
    });
    return () => {
      resetLanguages();
    };
  }, [lessonLanguage, paramLanguage, resetLanguages, setLanguages]);
};

export const WithAcademyLanguageWatcher = props => {
  useWatchAcademyLanguage(props);
  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};